import { memo, useCallback } from "react";
import RouteForm from "../../routeForm/routeForm";
import SegmentationRoute from "../../segmentationRoute/segmentationRoute";
import SidebarHeader from "./sidebarHeader";
import RouteSummary from "./routeSummary";
import NavigationControls from "./navigationControls";
import CollapsedRouteCard from "./collapsedRouteCard";
import SidebarFooter from "./sidebarFooter";
import { useMapRouteStore } from "@/stores/mapRouteStore";

type Props = {
  isCollapsed: boolean;
  setIsCollapsed: React.Dispatch<React.SetStateAction<boolean>>;
};

const SideBar = memo(function SideBar({ isCollapsed, setIsCollapsed }: Props) {
  const direction = useMapRouteStore((s) => s.direction);

  const hasRoute = !!direction;
  const showCollapsedCard = isCollapsed && hasRoute;

  const handleExpand = useCallback(() => {
    setIsCollapsed(false);
  }, [setIsCollapsed]);

  return (
    <div
      className="fixed top-0 left-0 w-[380px] z-[90] bg-white shadow-lg flex flex-col"
      style={{
        height: isCollapsed ? "auto" : "100vh",
        borderRadius: isCollapsed ? "0 0 16px 0" : "0",
        transition: "border-radius 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
      }}
    >
      {/* Header with Search */}
      <SidebarHeader
        isCollapsed={isCollapsed}
        setIsCollapsed={setIsCollapsed}
      />

      {/* Collapsed Route Card - показывается только при наличии маршрута */}
      <div
        style={{
          maxHeight: showCollapsedCard ? "130px" : "0",
          opacity: showCollapsedCard ? 1 : 0,
          overflow: "hidden",
          transition:
            "max-height 0.4s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
        }}
      >
        <CollapsedRouteCard onExpand={handleExpand} />
      </div>

      {/* Main Content */}
      <div
        className="flex flex-col flex-1"
        style={{
          maxHeight: isCollapsed ? "0" : "100vh",
          opacity: isCollapsed ? 0 : 1,
          overflow: "hidden",
          pointerEvents: isCollapsed ? "none" : "auto",
          transition: hasRoute
            ? "max-height 0.4s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1)"
            : "max-height 0.08s cubic-bezier(0.4, 0, 0.2, 1)",
        }}
      >
        {/* Route Form */}
        <div className="shrink-0">
          <RouteForm />
        </div>

        {/* Route Summary */}
        {direction && <RouteSummary />}

        {/* Navigation Controls */}
        {direction && <NavigationControls />}

        {/* Segmentation Route */}
        <div className="flex-1 flex flex-col overflow-hidden">
          <SegmentationRoute />
        </div>

        {/* Footer */}
        <div className="mt-auto shrink-0">
          <SidebarFooter />
        </div>
      </div>
    </div>
  );
});

export default SideBar;
